import React from 'react'
import PropTypes from 'prop-types';

const KeyFigures = ({ color, icon, text, figure }) => (
  <div className={`panel panel-${color}`}>
    <div className="panel-heading">
      <div className="row">
        <div className="col-xs-3">
          <i className={`fa ${icon} fa-5x`}></i>
        </div>
        <div className="col-xs-9 text-right">
          <div className="huge">{figure}</div>
          <div>{text}</div>
        </div>
      </div>
    </div>
  </div>
)

KeyFigures.propTypes = {
  color: PropTypes.string.isRequired,
  icon: PropTypes.string.isRequired,
  text: PropTypes.string.isRequired,
  figure: PropTypes.any.isRequired,
}

export default KeyFigures
